// extracted by mini-css-extract-plugin
module.exports = {"title":"Child_title__3TW98","addMenber":"Child_addMenber__jWtW1","delete":"Child_delete__m7NjR","childList":"Child_childList__b5cC5"};